var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriseenEnterpriseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.74 26.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b395;\n      }\n\n      .cls-2 {\n        fill: #fbb03b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 7.28,
    width: 0.47,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.56,
    y: 7.28,
    width: 0.46,
    height: 11.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.39,
    y: 7.28,
    width: 0.46,
    height: 11.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.06,
    y: 7.28,
    width: 1.39,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.06,
    y: 7.28,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.48,
    y: 7.28,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.98,
    y: 7.28,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.56,
    y: 7.28,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.87,
    y: 7.28,
    width: 0.97,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.84,
    y: 7.28,
    width: 0.97,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.84,
    y: 7.28,
    width: 1.39,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.57,
    y: 7.28,
    width: 0.62,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.72,
    y: 7.28,
    width: 0.62,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.68,
    y: 7.28,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.4,
    y: 7.28,
    width: 0.99,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.34,
    y: 7.28,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.64,
    y: 7.28,
    width: 0.97,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.34,
    y: 7.28,
    width: 0.62,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.45,
    y: 7.28,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.17,
    y: 7.28,
    width: 0.99,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.03,
    y: 24.28,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .05) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 24.25,
    width: 0.28,
    height: 2.4,
    transform: "translate(-.09 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.74,
    y: 24.25,
    width: 0.28,
    height: 2.4,
    transform: "translate(-.09 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.68,
    y: 24.28,
    width: 0.84,
    height: 2.42,
    transform: "translate(-.09 .05) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.88,
    y: 24.27,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .05) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 24.27,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .06) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.64,
    y: 24.27,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .06) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 24.27,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .06) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 24.26,
    width: 0.59,
    height: 2.42,
    transform: "translate(-.09 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.39,
    y: 24.25,
    width: 0.59,
    height: 2.42,
    transform: "translate(-.09 .08) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 24.25,
    width: 0.84,
    height: 2.42,
    transform: "translate(-.09 .08) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.63,
    y: 24.26,
    width: 0.38,
    height: 2.42,
    transform: "translate(-.09 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.53,
    y: 24.25,
    width: 0.38,
    height: 2.42,
    transform: "translate(-.09 .08) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.28,
    y: 24.26,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 24.26,
    width: 0.6,
    height: 2.42,
    transform: "translate(-.09 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.32,
    y: 24.24,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.31,
    y: 24.24,
    width: 0.59,
    height: 2.42,
    transform: "translate(-.09 .1) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.34,
    y: 24.24,
    width: 0.38,
    height: 2.42,
    transform: "translate(-.09 .1) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.99,
    y: 24.24,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.09 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.42,
    y: 24.24,
    width: 0.6,
    height: 2.42,
    transform: "translate(-.09 .1) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.13 19.72 7.03 19.72 6.52 26.59 12.64 26.71 12.69 24.33 9.85 24.28 10.13 19.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,23.23l19.14-.11-2.33-20.15h-3.76c-.11,0-.23-.02-.33-.07-.3-.14-.53-.36-.66-.5-.05-.05-.08-.11-.12-.17l-.62-1.21-.04-.08c-.36-.59-1.02-.95-1.71-.95h-.01l-6.64.04c-.74,0-1.41.41-1.75,1.07l-.57,1.19c-.07.15-.18.29-.32.38-.18.13-.38.21-.54.26-.08.02-.16.04-.24.04h-4.1s-.21,3.52-.21,3.52h2.78s.04-.97.04-.97l11.41.03h4.92s1.42,14.6,1.42,14.6l-15.71.2-.05,2.88ZM15.17,2.97l.29-.6c.08-.16.24-.27.42-.27l5.9-.03c.22,0,.42.12.52.32l.3.58h-7.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriseenEnterpriseIcon);
export default __webpack_public_path__ + "static/media/priseen-enterprise-icon.575bb73156d407e162187eb8e9799c2e.svg";
export { ForwardRef as ReactComponent };